// frontend/src/components/LaborRates/RefreshOpenPrompt.tsx
import React from 'react';
import { Modal } from 'antd';
export function RefreshOpenPrompt(props: { open: boolean; count: number; newRate: number; onConfirm: () => void; onSkip: () => void }) {
  const { open, count, newRate, onConfirm, onSkip } = props;
  return (
    <Modal open={open} centered title="Update open estimates?" okText={`Update ${count}`} cancelText="Skip" onOk={onConfirm} onCancel={onSkip}>
      {count} open estimate/work-order line(s) use this rate. Update them to ${newRate.toFixed(2)}/hr?
    </Modal>
  );
}
